// src/theme/fonts.ts
// 自前ホストのプレミアム日本語フォント（Capacitorオフライン/CSP対応・CDN不要）。
// 本文: Zen Kaku Gothic New（クリーンなゴシック）
// 見出し: Zen Old Mincho（明朝で権威・大人の質感）
// ウェイトは最小限(400/700 + 見出し700)。日本語フォントは1ウェイト≈120分割ファイルになるため、
// ウェイトを増やすほど初回表示のフォント要求数が跳ね上がる(500/900/600 は fallback 合成で十分)。
import '@fontsource/zen-kaku-gothic-new/400.css';
import '@fontsource/zen-kaku-gothic-new/700.css';
import '@fontsource/zen-old-mincho/700.css';

export const FONT_SANS =
    '"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", system-ui, -apple-system, sans-serif';
export const FONT_SERIF =
    '"Zen Old Mincho", "Hiragino Mincho ProN", "Yu Mincho", serif';
